var React = require('react');

function PrevInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18.7158","r":"17","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M19.5 23.7158L14.6852 19.1426C14.4383 18.8987 14.4383 18.5329 14.6852 18.289L19.5 13.7158","stroke":"white","strokeWidth":"1.8529","strokeMiterlimit":"10","strokeLinecap":"round","key":1})]);
}

PrevInline.defaultProps = {"width":"36","height":"37","viewBox":"0 0 36 37","fill":"none"};

module.exports = PrevInline;

PrevInline.default = PrevInline;
